import * as React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { InfopankLegalStatus } from '@/lib/enums/infopankLegalStatus.enum';
import { SearchCompanyItem, SearchResponse } from '@/apiTypes/types';
import { Locale } from '@/lib/enums/locale.enum';
import { getInternalLink } from '@/lib/helpers/getInternalLink';

interface IProps {
  companies: SearchResponse['companies']['items'];
}

const SearchCompaniesList: React.FC<IProps> = ({ companies }) => {
  const { t, i18n } = useTranslation();
  return (
    <React.Fragment>
      {companies.map((company: SearchCompanyItem) => (
        <tr key={company.id}>
          <td>
            <Link
              href={getInternalLink('Company', company.id, i18n.language as Locale, company.name)}
              prefetch={false}
              draggable={false}
            >
              {company.name}
            </Link>{' '}
            {(company.legalStatus as InfopankLegalStatus) === InfopankLegalStatus.Deleted && (
              <span className="text-intent-danger">{company.legalStatus}</span>
            )}{' '}
            {company.matchedFormerNames?.length > 0 && (
              <span>
                ({t('components.search.formerName')} {company.matchedFormerNames[0]})
              </span>
            )}
          </td>
          <td
            data-label={t('components.search.registrationCode')}
            className="align-right label-secondary"
          >
            {company.registrationCode}
          </td>
        </tr>
      ))}
    </React.Fragment>
  );
};

export default SearchCompaniesList;
